











import Vue from 'vue'
import Inputmask from 'inputmask'

import style from '../text-input/style.module.scss'

export default Vue.extend({
name: 'price-input',
  props: {
    value: [String, Number],
    disabled: Boolean,
    error: Boolean,
  },
  data() {
    return {
      settings: {
        alias: 'numeric',
        groupSeparator: ' ',
        autoUnmask: true,
        autoGroup: true,
        prefix: '',
        digits: 2,
        groupSize: 3,
        digitsOptional: false,
        rightAlign: false,
        allowMinus: false,
        min: 0
      },
      nvalue: this.value,
      style: style
    }
  },
  watch: {
    nvalue(value) {
      this.$emit('input', value);
    }
  },
  computed: {
      model: {
        get(): string | number {
          return this.value
        },
        set(value: string): void {
          this.nvalue = value
        }
      }
  },
  directives: {
    'local-mask': {
      bind: function(el, binding) {
        Inputmask(binding.value).mask(el);
      }
    }
  }
})
